/**
 * Reusable campaign container component
 * Provides consistent layout and styling for campaign sections (tournaments, prize-pop, etc.)
 */
import React, { type FC, memo, type ReactNode } from 'react';
import { useCampaignSectionBase } from '../../_hooks/useCampaignSection';
import styles from './CampaignSectionContainer.module.css';

interface CampaignContainerProps {
  sectionName: string;
  isActive: boolean;
  children: ReactNode;
  additionalProps?: Record<string, string>;
  className?: string;
}

const CampaignSectionContainer: FC<CampaignContainerProps> = ({
  sectionName,
  isActive,
  children,
  additionalProps,
  className
}) => {
  const { createContainerProps } = useCampaignSectionBase({ name: sectionName }, isActive);
  
  const containerProps = createContainerProps(additionalProps);

  return (
    <div 
      className={`${styles.campaignSectionContainer} ${className || ''}`}
      {...containerProps}
    >
      {children}
    </div>
  );
};

export default memo(CampaignSectionContainer);
